import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";

const GetAllOnlineStaffCount = () => {
  return ApiHelper.getRequest(API_URLS.GET_ALL_ONLINE_STAFFCOUNT);
};

const GetAllClinicCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_ALL_CLINIC_COUNT, data);
};

const GetAllStaffCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_ALL_STAFF_COUNT, data);
};

const getAllClientsCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_ALL_CLIENTS_COUNT, data);
};

const get835BillingCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_835BILLING_COUNT, data);
};

const get837BillingCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_837BILLING_COUNT, data);
};

const getBillingClaimCount = (data) => {
  return ApiHelper.postRequest(API_URLS.GET_BILLING_CLAIM_COUNT, data);
};


export const dashboardService = {
  GetAllOnlineStaffCount,
  GetAllClinicCount,
  GetAllStaffCount,
  getAllClientsCount,
  get835BillingCount,
  get837BillingCount,
  getBillingClaimCount
};
